module.exports = __webpack_public_path__ + "img/group-12@3x.30825bc.png";